import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserSupportModalComponent } from './browser-support-modal.component';
import { BrowserSupportService } from './browser-support.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@NgModule({
  declarations: [ BrowserSupportModalComponent ],
  providers: [ BrowserSupportService, DeviceDetectorService ],
  imports: [ CommonModule ],
  exports: [ BrowserSupportModalComponent ],
})
export class BrowserSupportModule { }
